import { useContext } from 'react';
import { DataContext } from '../contexts/DataProvider.context';

export const useSearchData = () => {
  const { searchRequest } = useContext(DataContext);
  
  return {
    query: searchRequest?.q || '',
  };
}; 